export const nodeIds = {
    MANUAL_TRIGGER: 'bbdc3ee9-040b-4870-9cd4-f3216257855f',
    SEARCH_CAMPAIGNS: 'bc44caa1-3dcb-41af-9700-843f939fa1b4',
    SEARCH_CREATIVES: '9138929b-2878-45ee-8f9e-b555fb09e4af',
    GET_LINKEDIN_CAMPAIGN_LEVEL_AD_ANALYTICS: '85a4b5a4-e029-40d9-8873-d283c3fa5700',
    GET_LINKEDIN_AD_ANALYTICS: 'db9c29fe-913e-4524-9ce4-a0c5102323a7',
    MERGE_ANALYTICS_WITH_CAMPAIGN: 'e461479c-7354-4598-b051-efb0204925d2',
    ANALYZE_AD_ANALYTICS_DATA: 'e2c35120-c920-4cb4-abea-857026aaf9a5',
    EVALUATE_CAMPAIGN_BASED_ON_RULES: 'd31adb1a-a4f5-4002-9ef8-0900116e0485',
    PROCESS_OUTPUT: '6a443ec2-938b-4b1c-980e-55aa1e27bec3',
};

export const nodes = [
    {
        id: nodeIds.MANUAL_TRIGGER,
        display_name: "Manual Trigger",
        type: "workflow_module",
        action: "manual_trigger",
        credentials: [],
        description: "Manual trigger to start the LinkedIn campaign analysis workflow"
    },
    {
        id: nodeIds.SEARCH_CAMPAIGNS,
        display_name: "Search campaigns",
        type: "app_action",
        app: "linkedin",
        action: "search_campaigns",
        credentials: [],
        description: "Search and retrieve LinkedIn campaign data"
    },
    {
        id: nodeIds.SEARCH_CREATIVES,
        display_name: "Search creatives",
        type: "app_action",
        app: "linkedin",
        action: "search_creatives",
        credentials: [],
        description: "Search and retrieve LinkedIn creative data"
    },
    {
        id: nodeIds.GET_LINKEDIN_CAMPAIGN_LEVEL_AD_ANALYTICS,
        display_name: "Get analytics for campaigns",
        type: "app_action",
        app: "linkedin",
        action: "get_ad_analytics",
        credentials: [],
        description: "Retrieve campaign-level analytics from LinkedIn"
    },
    {
        id: nodeIds.GET_LINKEDIN_AD_ANALYTICS,
        display_name: "Get analytics for ads",
        type: "app_action",
        app: "linkedin",
        action: "get_ad_analytics",
        credentials: [],
        description: "Retrieve ad-level analytics from LinkedIn"
    },
    {
        id: nodeIds.MERGE_ANALYTICS_WITH_CAMPAIGN,
        display_name: "Merge analytics data & creative data",
        type: "workflow_module",
        action: "merge",
        credentials: [],
        description: "Merge analytics data with campaign and creative data"
    },
    {
        id: nodeIds.ANALYZE_AD_ANALYTICS_DATA,
        display_name: "Analyze ad analytics data",
        type: "app_action",
        app: "linkedin_campaign_analyser",
        action: "analyze_ad_analytics_data",
        credentials: [],
        description: "Analyze LinkedIn ad analytics data for insights"
    },
    {
        id: nodeIds.EVALUATE_CAMPAIGN_BASED_ON_RULES,
        display_name: "Evaluate campaign based on rules",
        type: "app_action",
        app: "linkedin_campaign_analyser",
        action: "evaluate_campaign_based_on_rules",
        credentials: [],
        description: "Evaluate campaign performance based on predefined rules"
    },
    {
        id: nodeIds.PROCESS_OUTPUT,
        display_name: "Process output",
        type: "app_action",
        app: "linkedin_campaign_analyser",
        action: "process_output",
        credentials: [],
        description: "Process and format the analysis output"
    },
];
